module.exports = __webpack_public_path__ + "static/media/serv_renovation.60e89351.png";